import { render, staticRenderFns } from "./EditorPage.vue?vue&type=template&id=2c5a690d&scoped=true&"
import script from "./EditorPage.vue?vue&type=script&lang=js&"
export * from "./EditorPage.vue?vue&type=script&lang=js&"
import style0 from "./EditorPage.vue?vue&type=style&index=0&id=2c5a690d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5a690d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VTextField})
